












































































































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';
import Choices from '@/store/modules/Choices';
import Viewpoints from '@/store/modules/Viewpoints';
import Scoring from '@/store/modules/Scoring';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import ViewpointFactorScore from '@/components/scoring-input/ViewpointFactorScore.vue';
import Decisions from '@/store/modules/Decisions';
import FactorValueDisplay from '@/components/common/FactorValueDisplay.vue';
import { FactorGroup } from '@/api/model/FactorResource';
import Modelling from '@/store/modules/Modelling';
import _ from 'lodash';

const decisionsModule = getModule(Decisions);
const choicesModule = getModule(Choices);
const viewpointModule = getModule(Viewpoints);
const scoringModule = getModule(Scoring);
const modellingModule = getModule(Modelling);
const workspaceOptionsModule = getModule(WorkspaceOptions);

@Component({
    components: { FactorValueDisplay, ViewpointFactorScore },
})
export default class TableChoiceScoringComparison extends Vue {
    @Prop()
    tableFactorGroup: FactorGroup;

    @Prop()
    columnWidths!: any;

    @Prop()
    choiceIds!: string[];

    @Prop({ default: 0, type: Number })
    factorLevel!: number;

    private selectedColumnId: null | string = null;

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get scoredChoices() {
        if (this.selectedViewpoint) {
            return scoringModule.viewpointScores[this.selectedViewpoint.viewpointId];
        }
    }

    get choices() {
        return choicesModule.choices;
    }

    get selectedViewpoint() {
        if (viewpointModule.activeViewpointId && viewpointModule.decisionViewpointsMap) {
            return viewpointModule.decisionViewpointsMap[viewpointModule.activeViewpointId];
        }
    }

    get factorResources() {
        return modellingModule.publishedModelFactorResources;
    }

    get orderedRows(): FactorGroup[] {
        return this.tableFactorGroup.childrenIds
            .map((f) => this.factorResources[f] as FactorGroup)
            .filter((f) => f && f.groupTypeDefinition.type === 'TABLE_ROW');
    }

    get orderedColumns(): FactorGroup[] {
        let orderedColumns = this.tableFactorGroup.childrenIds
            .map((f) => this.factorResources[f] as FactorGroup)
            .filter((f) => f && f.groupTypeDefinition.type === 'TABLE_COLUMN');
        this.selectedColumnId = orderedColumns[0].id;
        return orderedColumns;
    }

    get tableGrid() {
        let grid: any = {};
        this.orderedColumns.forEach((c) => {
            grid[c.id] = {};
            this.orderedRows.forEach((r) => {
                let factorIds = _.intersection(c.childrenIds, r.childrenIds);
                if (factorIds.length === 1) {
                    grid[c.id][r.id] = factorIds[0];
                }
            });
        });
        return grid;
    }

    get contributionFactors() {
        return _.groupBy(
            this.tableFactorGroup.childrenIds
                .map((id) => this.factorResources[id] as FactorGroup)
                .filter(
                    (fg) =>
                        fg.childrenIds.filter(
                            (f) =>
                                !this.viewpointFactorResources[f] ||
                                this.viewpointFactorResources[f].numWeightingDots !== 0
                        ).length > 0
                ),
            'id'
        );
    }

    get viewpointFactorResources() {
        if (this.selectedViewpoint) {
            return (
                viewpointModule.viewpointFactorResources[this.selectedViewpoint.viewpointId] || {}
            );
        }
        return {};
    }

    get choiceVisibility() {
        return workspaceOptionsModule.choiceVisibility;
    }

    get visibleChoices() {
        return this.choiceIds.filter((cId) => this.choiceVisibility[cId]);
    }

    get contributingVisibility() {
        return workspaceOptionsModule.contributingFactorVisibility;
    }

    get factorListTree() {
        return modellingModule.factorListTree;
    }

    get isFactorListActive() {
        return workspaceOptionsModule.activeFactorLists.length > 0;
    }

    get showNonListFactors() {
        return workspaceOptionsModule.showNonListFactors;
    }

     get leftCol() {
        let children = this.orderedColumns;
        let indexOfSelected = _.findIndex(children, ((val) => val.id === this.selectedColumnId))
        if(indexOfSelected === 0) {
            return children[children.length - 1].id
        }
        else {
            return children[indexOfSelected - 1].id
        }
    }

    get rightCol() {
        let children = this.orderedColumns;
        let indexOfSelected = _.findIndex(children, ((val) => val.id === this.selectedColumnId))
        if(indexOfSelected === children.length - 1) {
            return children[0].id
        }
        else {
            return children[indexOfSelected + 1].id
        }
    }

    get editComments() {
        return workspaceOptionsModule.editComments;
    }

    get showFactorData() {
        return workspaceOptionsModule.showFactorData;
    }

    private isFactorVisible(resourceId: string) {
        if (this.showNonListFactors || !this.isFactorListActive) {
            // return  this.contributingVisibility || (!this.contributingVisibility  && (!this.viewpointFactorResources[resourceId] || this.viewpointFactorResources[resourceId].numWeightingDots > 0))
            return true;
        } else {
            if (
                this.isFactorListActive &&
                this.factorListTree[resourceId] &&
                !this.showNonListFactors
            ) {
                return true;
            } else return false;
        }
    }

   private cycleLeft() {
        this.selectedColumnId = this.leftCol

    }

    private cycleRight() {
        this.selectedColumnId = this.rightCol
    }
}
